import React, { useState } from "react"
import { useTemplatePreviewCtx } from "lib/units/template/preview/TemplatePreviewProvider"
import { useDataCompare } from "."
import { CONVERSIONS } from "lib/utils"
import { evaluateConditionalItem } from "lib/utils/conditionals"

export default function useRenderStatement(){

  const { getApiFeedData }:any = useTemplatePreviewCtx() 
  const { compareData } = useDataCompare()

  const [ currentZoneIdx, setCurrentZoneIdx ] = useState<number>(0)
  const [ currentGroupRef, setCurrentGroupRef ] = useState<string>("")
  const [ currentItemRef, setCurrentItemRef ] = useState<string>("")

  
  function lookupApiValue(apiValueObj:any){
    // console.log(apiValueObj)
    const data = getApiFeedData(apiValueObj.path)
    return data
  }
  
  // function OLDevaluateConditionalItem(itemReportObj:any){
  //   console.log(itemReportObj)
  //   const itemObj = itemReportObj.itemObj
  //   let dataToEvaluate = lookupApiValue(itemObj.apiValueObj)

  //   if( itemObj.conversion !== undefined && itemObj.conversion !== "none" ){
  //     const conversion = CONVERSIONS.find( (conv:any) => conv.value === itemObj.conversion )
  //     if( conversion ){
  //       console.log("converting data")
  //       dataToEvaluate = conversion.method(dataToEvaluate)
  //       console.log("converted data", dataToEvaluate)
  //     }
  //   }

  //   const operator = itemObj.operator
  //   const expectedValue = itemObj.value

  //   const statement = `Evaluating ${itemObj.refid} with data ${dataToEvaluate} using operator ${operator} against expected value ${expectedValue}`

  //   itemReportObj = { ...itemReportObj, statement } 

  //   const {data, expValue, verdict}:any = compareData(dataToEvaluate, expectedValue, operator)
  //   itemReportObj = { ...itemReportObj, data, verdict }
  //   return itemReportObj
  // }
    
  // function evaluateConditionalGroup({ group, conditionalObj }:{ group:any; conditionalObj:any }){
  //   let itemResults:any = { passed: [], failed: [] } 
  //   group.items.forEach( (item:any) => {
  //     const verdict = evaluateConditionalItem(item, conditionalObj)
  //     if( verdict ){
  //       itemResults = { ...itemResults, passed: [...itemResults.passed, group] }
  //     } else {
  //       itemResults = { ...itemResults, failed: [...itemResults.failed, group] }
  //     }
  //   })
  //   return itemResults
  // }
    
    
  function generateStatementReport(statementObj:any, clientApiData:any){
    let summary = '';
    let report:any = { statement: statementObj, zonesPassed: 0, zonesFailed: 0, zones: [] }
    const conditionalObj = statementObj.conditional

    if( !conditionalObj || !conditionalObj.zones ){
      return {
        ...report,
        zones: [{ groupsPassed: 0, groupsFailed: 0, groups: [] }]
      }
    }

    conditionalObj.zones?.forEach( (zone:any, idx:number) => {
      let zoneResults:any = { groupsPassed: 0, groupsFailed: 0, groups: [] }
      // console.log(`creating report record for zone ${currentZoneIdx}`)

      const groups = zone.groups
      groups.forEach( (group:any) => {
        let groupReportObj:any = { zone: idx, group: group.refid, itemsPassed: 0, itemsFailed: 0, items: [] }
        setCurrentGroupRef(group.refid)
        
        group.items.forEach( (item:any) => {
          setCurrentItemRef(item)
          let itemReportObj:any = {
            zone: idx,
            group: group.refid,
            item: item,
            itemObj: conditionalObj.items.find( (i:any) => i.refid === item )
          }
          
          itemReportObj = evaluateConditionalItem(clientApiData, itemReportObj.itemObj)
          groupReportObj.items = [...groupReportObj.items, itemReportObj]
          if( itemReportObj.verdict ){
            groupReportObj = { ...groupReportObj, itemsPassed: groupReportObj.itemsPassed + 1 }
          } else {
            groupReportObj = { ...groupReportObj, itemsFailed: groupReportObj.itemsFailed + 1 }
          }
        })

        // only 1 item in each group needs to pass for the group to pass
        const verdict = groupReportObj.itemsPassed > 0
        if( verdict ){
          zoneResults = { ...zoneResults, groupsPassed: zoneResults.groupsPassed + 1 }
        } else {
          zoneResults = { ...zoneResults, groupsFailed: zoneResults.groupsFailed + 1 }
        }
        zoneResults = { ...zoneResults, groups: [...zoneResults.groups, groupReportObj] }
      })

      // every zone must pass for the test to pass
      const verdict = zoneResults.groupsPassed === groups.length
      if( verdict ){
        report = { ...report, zonesPassed: report.zonesPassed + 1 }
      } else {
        report = { ...report, zonesFailed: report.zonesFailed + 1 }
      }
      
      report = { ...report, zones: [...report.zones, zoneResults] }
    })

    return report
  }
  
  return {
    evaluateConditionalItem,
    generateStatementReport
  }

}